import { useCallback, useState } from "react";
import ReactModal from "react-modal";
import TierList from "../components/tierList";
import { museumList } from "../../lists/museums";

export default function Museums() {

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = useCallback((index) => {
        setShowModal(true);
    }, []);
    const handleCloseModal = useCallback((index) => {
        setShowModal(false);
    }, []);

    return (
        <>
            <div className="artwork-tape-header container">
                <div className="row">
                    <div className="col-12">
                        <div className="artwork-tape-header-titles">Museums</div>
                        <p className="align-center">Total Visits: {museumList.length} </p>
                        <div className="gaming-tier-list-button" onClick={handleOpenModal}>
                            <div className="index-card-header">Museums Tier List</div>
                        </div>
                        <img className="usa-map" alt="muesums" src={process.env.PUBLIC_URL + "/images/experiences/Museums.jpg"} />
                    </div>
                </div>
            </div>
            <div className="mt-5 col-12 col-md-4">
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                >
                    <div>Photos</div>
                    <div><strong>Art : </strong> American Sign Museum</div>
                    <div><strong>Science : </strong> Museum of Osteology</div>
                    <div><strong>Transportation : </strong> California State Railroad Museum</div>
                    <div><strong>Unique : </strong> Museum of the Bible</div>
                    <div><strong>Tour : </strong> Strataca</div>
                    <div><strong>Military : </strong> National Museum of the U.S. Air Force</div>
                    <div><strong>Favorite : </strong> Musical Instrument Museum</div>
                    <div><strong>Small : </strong>History of Diving Museum</div>

                    <TierList
                        items={museumList}
                        columns={2}
                    />
                    <button onClick={handleCloseModal}>Close Window</button>
                </ReactModal>
            </div>
        </>
    )
}